<div class="loginBodyContainer">
  <div class="LoginHeadderContainer">
    <p class="LoginERPTitle">{{ 'HOME.TITLE' | translate }}
      <i class="material-icons">cloud_queue</i>
    </p>
  </div>

  <!-- <mat-form-field style="z-index: 1;">
    <mat-label>{{ 'HOME.SELECT' | translate }}</mat-label>
    <mat-select #langSelect (selectionChange)="translate.use(langSelect.value);setLanguage(langSelect.value);">
      <mat-option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">{{ lang }}</mat-option>
    </mat-select>
  </mat-form-field> -->
  
  <div class="CompanyImage">
    <img [src]="logoImage" alt="Logo">
  </div>

  <div class="example-form" *ngIf="!isRegistering && !ShowMFA" style="background: #fff;">
  
      <p class="LoginFormTitle">{{ 'Login.Title' | translate }}</p>
  
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>{{ 'Login.User' | translate }}</mat-label>
        <input class="LogInTextBox" [disabled]="loading" matInput placeholder="username" value="" [(ngModel)]="loginUserName" required>
      </mat-form-field>
    
      <mat-form-field style="width: 100%;margin-bottom: 5px;" appearance="outline">
        <mat-label>{{ 'Login.Password' | translate }}</mat-label>
        <input class="LogInTextBox" [disabled]="loading" matInput placeholder="{{ 'Login.Password' | translate }}" [type]="hide ? 'password' : 'text'" [(ngModel)]="loginPassword" required>
        <mat-icon style="cursor: pointer;" [disabled]="loading" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
  
          <mat-checkbox [disabled]="loading" class="example-margin" color="primary" style="margin-bottom: 14px;width: 100%;font-size: 11px;color: #495057;" [(ngModel)]="this.rememberMe" [checked]="this.rememberMe" (click)="DeleteRememberedCredentials();">{{ 'Login.RememberMe' | translate }}</mat-checkbox>

          <button [disabled]="loading" mat-raised-button class="loginButton" (click)="Login();">
            <i class="material-icons ButtonCenterImage">login</i>
            <span>{{ 'Login.LoginButton' | translate }}</span>
          </button>

          <p class="NoAccountTitle">{{'NoAccountQuestion' | translate}}</p>
          <p class="NoAccountDescription">{{'ResolveInvoicingProblemsBannerText' | translate}}</p>

          <button [disabled]="loading" mat-raised-button class="loginButton secondary" style="margin-top: 6px;" (click)="isRegistering = true;">
            <i class="material-icons ButtonCenterImage">person_add</i>
            <span>{{ 'Login.NewUserButton' | translate }}</span>
          </button>

          <p class="NoAccountTitle">{{'ForgotPasswordTitle' | translate}}</p>
          <p class="NoAccountDescription" style="margin-top:0px;">{{'ForgotPasswordTitleDescription' | translate}}</p>
          <button [disabled]="loading" mat-button color="primary" class="forgotPasswordButton" (click)="SendRecoverPasswordEmail();">
            <i class="material-icons">settings_backup_restore</i>
            {{ 'RecoverPassword' | translate }}
          </button>

          <!-- B2B Registration Section -->
          <div class="b2b-registration-section">
            <div class="b2b-divider">
              <span class="b2b-divider-line"></span>
              <span class="b2b-divider-text">B2B</span>
              <span class="b2b-divider-line"></span>
            </div>
            <p class="NoAccountDescription" style="margin-top:8px;">{{ 'B2BRegistrationDescription' | translate }}</p>
            <a routerLink="/b2b/register" class="b2b-register-button">
              <i class="material-icons">business</i>
              <span>{{ 'B2BRegistration' | translate }}</span>
              <i class="material-icons arrow-icon">arrow_forward</i>
            </a>
          </div>

          <p class="ErrorLoginP" *ngIf="LoginResponse.Status == -1 || LoginResponse.Status == 0;">{{LoginResponse.Message}}</p>
          <p class="NoAccountDescription">{{'CopyRightRow' | translate}}</p>

        <mat-progress-bar mode="indeterminate" *ngIf="loading" class="loginIntermediateProgressBar"></mat-progress-bar>
  </div>

  <div class="example-form" *ngIf="!isRegistering && ShowMFA" style="background: #fff;">
  
    <button [disabled]="loading" mat-raised-button class="loginButton secondary backButton" (click)="isRegistering = false; ShowMFA = false;">
      <i class="material-icons">arrow_back</i>
      <span>{{ 'Login.BackButton' | translate }}</span>
    </button>
    <p class="LoginFormTitle">{{ 'EnterToken' | translate }}</p>

    <div class="MFAImage">
      <svg class="MFAImageSVG" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M256 127.998C256 198.696 198.694 256 127.997 256 57.304 256 0 198.696 0 127.998 0 57.305 57.304 0 127.997 0 198.694 0 256 57.305 256 127.998z" fill="#EC1C24"/><path d="M117.024 100.89l30.691 30.68c4.43 4.436 11.623 4.436 16.064 0 4.431-4.435 4.441-11.622 0-16.058L133.086 84.82C111.125 62.854 75.631 62.5 53.204 83.704a9.536 9.536 0 0 0-.605.548c-.098.098-.178.202-.275.29-.1.096-.202.182-.297.278-.194.193-.371.396-.54.597-21.215 22.437-20.85 57.932 1.113 79.897L83.292 196c4.44 4.433 11.623 4.433 16.062 0 4.442-4.437 4.442-11.633.011-16.06l-30.693-30.691c-13.398-13.393-13.488-35.129-.278-48.637 13.506-13.21 35.23-13.114 48.63.279zm39.612-40.873c-4.435 4.437-4.435 11.623.012 16.059l30.681 30.693c13.39 13.392 13.477 35.125.268 48.636-13.51 13.2-35.227 13.112-48.623-.282l-30.692-30.689c-4.438-4.437-11.633-4.437-16.066 0-4.443 4.433-4.443 11.642 0 16.065l30.682 30.694c21.968 21.965 57.458 22.322 79.889 1.116.208-.184.404-.355.61-.549.094-.095.182-.192.273-.29.1-.095.197-.183.29-.289.197-.183.365-.384.54-.594 21.215-22.428 20.86-57.911-1.102-79.889l-30.692-30.682c-4.436-4.443-11.638-4.443-16.07.001z" fill="#FFF"/></svg>
    </div>

    <mat-form-field class="example-full-width" appearance="outline">
      <input autocomplete="off" class="MFAToken" [disabled]="loading" matInput placeholder="{{ 'MFAToken' | translate }}" value="" [(ngModel)]="MFAToken" required>
    </mat-form-field>

        <button [disabled]="loading" mat-raised-button class="tokenButton" (click)="VerifyMFAToken();">
          <i class="material-icons ButtonCenterImage">verified_user</i>
          <span>{{ 'VerifyToken' | translate }}</span>
        </button>
      
        <p class="ErrorLoginP" *ngIf="LoginResponse.Status == -1 || LoginResponse.Status == 0;">{{LoginResponse.Message}}</p>
    
        <p class="NoAccountDescription">{{'CopyRightRow' | translate}}</p>
        <p class="GeneralInfoRow">{{'ContactRow' | translate}}</p>
        <p class="GeneralInfoRow">{{'AllRightsReceived' | translate}}</p>

      <mat-progress-bar mode="indeterminate" *ngIf="loading" class="loginIntermediateProgressBar"></mat-progress-bar>
</div>
  
  <div class="example-form" *ngIf="isRegistering && !ShowMFA" style="background: #fff;margin-top: 50px;">
  
      <button [disabled]="loading" mat-raised-button (click)="isRegistering = false;">{{ 'Login.BackButton' | translate }}</button>
      <p class="LoginFormTitle">{{ 'Login.RegisterNowTitle' | translate }}</p>
      
      <form [formGroup]="signin">
  
              <mat-form-field style="width: 100%;margin-bottom: 5px;">
              <input matInput placeholder="{{ 'Login.Email' | translate }}" [type]="'emailInput'" formControlName="email" required>
              </mat-form-field>
  
              <mat-form-field style="width: 100%;margin-bottom: 5px;">
                <input matInput placeholder="{{ 'Login.Username' | translate }}" [type]="'usernameInput'" formControlName="username" required>
                </mat-form-field>
  
              <mat-form-field style="width: 100%;margin-bottom: 5px;">
                <input matInput placeholder="{{ 'Login.Phone' | translate }}" [type]="'phoneInput'" formControlName="phone" required>
                </mat-form-field>

                <mat-form-field style="width: 100%;margin-bottom: 5px;">
                  <input matInput placeholder="{{ 'Name' | translate }}" [type]="'nameInput'" formControlName="name" required>
                  </mat-form-field>
  
          <mat-form-field style="width: 100%;margin-bottom: 5px;">
              <input matInput placeholder="{{ 'Login.Password' | translate }}" [type]="hide ? 'password' : 'text'" formControlName="password" required>
              <mat-icon style="cursor: pointer;" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field>
  
              <mat-form-field style="width: 100%;margin-bottom: 5px;">
                  <input matInput placeholder="{{ 'Login.ConfirmPassword' | translate }}" [type]="hideCPassword ? 'confirmPassword' : 'text'" formControlName="confirmPassword" required>
                  <mat-icon style="cursor: pointer;" matSuffix (click)="hideCPassword = !hideCPassword">{{hideCPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
          </form>
  
        <button [disabled]="loading" mat-raised-button class="loginButton" style="margin-top: 12px;" (click)="RegisterNewUser();">
          <i class="material-icons ButtonCenterImage">check_circle</i>
          <span>{{'Login.RegisterNowTitle' | translate}}</span>
        </button>
  
        <mat-progress-bar mode="indeterminate" *ngIf="loading" class="loginIntermediateProgressBar"></mat-progress-bar>
  </div>
</div>

<router-outlet></router-outlet>